export default {
  "content": "<g clip-path=\"url(#icon_reload_outlined_svg__a)\"><path d=\"M16 8c0 4.41-3.59 8-8 8s-8-3.59-8-8 3.59-8 8-8c2.55 0 4.94 1.23 6.44 3.25l.36-2.8c.04-.27.3-.47.56-.43.28.04.47.29.44.56l-.54 4.14c-.02.14-.09.26-.21.34-.08.06-.18.1-.29.1-.03 0-.07-.01-.1-.01l-4.09-.85a.495.495 0 01-.39-.59.5.5 0 01.59-.39l2.9.6C12.35 2.11 10.24 1.01 8 1.01 4.15 1.01 1.01 4.15 1.01 8S4.15 14.99 8 14.99s6.99-3.14 6.99-6.99c0-.28.22-.51.5-.51s.51.23.51.51z\"/></g><defs><clipPath id=\"icon_reload_outlined_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};